module.exports = new __parcel__URL__("LightEmptyState.1b72e55d.png").toString();